import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {commitMutation, graphql} from 'react-relay';
import {omit} from 'lodash';

const mutation = graphql`
	mutation updateProjectBudgetPageMutationModernMutation($input: UpdateProjectInput!) {
		updateProject(input: $input) {
			errors
			project {
                id
                estimationUnit # warnings
                useBaseline
                projectStartYear # warnings
                projectStartMonth # warnings
                projectStartDay # warnings
                projectEndYear
                projectEndMonth
                projectEndDay
                companyProjectId
                warnings {
                    id
                    year
                    month
                    day
                    tasks(first: 10000) {
                        edges {
                            node {
                                id
                                name
                                startDay
                                startMonth
                                startYear
                                deadlineDay
                                deadlineMonth
                                deadlineYear
                                estimateLow
                                estimateHigh
                                estimateForecast
                            }
                        }
                    }
                    personIds
                    expenseItems(first: 10000) {
                        edges {
                            node {
                                id
                                name
                                expenseYear
                                expenseMonth
                                expenseDay
                            }
                        }
                    }
                    timeRegistrations(first: 10000) {
                        edges {
                            node {
                                id
                                year
                                month
                                day
                                minutesRegistered
                                person {
                                    id
                                    fullName
                                    profilePictureId
                                    profilePictureDefaultId
                                }
                                task {
                                    name
                                }
                            }
                        }
                    }
                }
                ...BudgetPage_project
                ...expensesPage_project
                ...ratesAndInternalCostPage_project
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	Util.localStorageDeleteFincancialMap();
	const changes = [];

	let status;

	for (const key of Object.keys(input)) {
		if (['id', 'project'].includes(key) || input[key] === undefined) {
			continue;
		}

		if (key === 'status') {
			status = input.status;
		}

		changes.push(key);
	}

	const options = {_Changed: changes};
	if (status) {
		options.Status = status;
	}
	tracking.trackEvent('Project Updated', options);

	const cleanedVariables = omit(input, ['project']);
	cleanedVariables.id = input.project.id;

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedVariables}};
	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
